import {Menu, MenuItem} from '@ariakit/react'
import styled, {css} from 'styled-components'

export const StyledGroupActionsMenu = styled(Menu)(
    ({theme: {palette, shadows}}) => css`
        background-color: ${palette.neutral['white']};
        border-radius: 8px;
        box-shadow: ${shadows.md};
        overflow: hidden;
        width: 140px;
    `
)

export const StyledGroupActionsMenuItem = styled(MenuItem)<{$variant?: 'neutral' | 'danger'}>(
    ({theme: {palette, spacing}, $variant = 'neutral'}) => css`
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        width: 100%;
        color: ${$variant === 'danger' ? palette.danger['600'] : palette.neutral['900']};
        transition: background-color 0.2s ease;

        &:hover {
            background-color: ${palette.neutral['100']};
        }

        &[aria-disabled='true'] {
            cursor: not-allowed;
            color: ${palette.neutral['400']};
        }
    `
)
